import { render } from "./PlayButton.vue?vue&type=template&id=96ce91b4&scoped=true"
import script from "./PlayButton.vue?vue&type=script&lang=js"
export * from "./PlayButton.vue?vue&type=script&lang=js"

import "./PlayButton.vue?vue&type=style&index=0&id=96ce91b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-96ce91b4"

export default script